import { createFileRoute } from '@tanstack/react-router'
import { resolveLegacyAdminPath } from '@/lib/legacy-routes'
import { redirectFromLegacyPath, splitSplat } from '@/lib/legacy-redirect'

/** The old `/admin/…` tree. See `resolveLegacyAdminPath`. */
export const Route = createFileRoute('/admin/$')({
  loader: ({ context: { queryClient }, params }) =>
    redirectFromLegacyPath(queryClient, resolveLegacyAdminPath(splitSplat(params._splat))),
})
